<app-programtitle title="Time in seconds"></app-programtitle>
<p> Write a program to calculate hours/minutes/seconds from seconds.</p>
<app-editor code="{{program}}"> </app-editor>